import {UserRepository} from '../repository/UserRepository';
import {DashboardUser, UserFilters} from '../models/user.model';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class GetUsersUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (filters?: UserFilters): Promise<{ users: DashboardUser[]; pagination: any }> {
    try {
      // Validate pagination parameters
      if (filters?.page && filters.page < 1) {
        throw new AppError('رقم الصفحة يجب أن يكون أكبر من 0', ErrorType.VALIDATION);
      }

      if (filters?.limit && (filters.limit < 1 || filters.limit > 100)) {
        throw new AppError('عدد النتائج يجب أن يكون بين 1 و 100', ErrorType.VALIDATION);
      }

      // Validate role ID if provided
      if (filters?.roleId && filters.roleId < 1) {
        throw new AppError('معرف الدور يجب أن يكون رقماً موجباً', ErrorType.VALIDATION);
      }

      // Get users from repository
      const result = await this.userRepository.getUsers(filters);

      return result;
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
